import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function batchDelete({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      okText: 'Delete',
      okType: 'danger',
      callback: function () {
        httpClient
          .post('Business/ApprovalReportingAuthority/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must select at least one reporting authority.');
  }
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: pageComponent });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ approvalReportingAuthorityAddFromTemplateShow: true });
  component.approvalReportingAuthorityAddFromTemplate.current?.setState({ activeKey: 0 });
  setTimeout(() => {
    component.approvalReportingAuthorityAddFromTemplate.current?.formRef.current?.resetFields();
    component.approvalReportingAuthorityAddFromTemplate.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], reportingAuthorityTemplateList: [], reportingAuthorityTemplatePresetDataSource: [] });
    setTimeout(() => {
      component.approvalReportingAuthorityAddFromTemplate.current?.getReportingAuthorityTemplate();
      component.approvalReportingAuthorityAddFromTemplate.current?.getReportingAuthorityTemplatePresetDataSource();
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function addApprovalReportingAuthorityPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (!globalFunction.isNullOrEmpty(pageComponent.state.approvalData.LgaName)) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('AuthorityName', pageComponent.state.approvalData.LgaName);
  }
}
